import React from 'react'
import { LatLngExpression } from 'leaflet'
import { Popup } from 'react-leaflet'
import Avatar from '@mui/material/Avatar'
import Box  from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import EventRoundedIcon from '@mui/icons-material/EventRounded'
import TimelapseIcon from '@mui/icons-material/Timelapse'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded'
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded'
import EnhancedMarker from '@/javascript/presentation/components/enhanced-marker/enhanced-marker'

type Props = {
  workId: number
  position: LatLngExpression
  workStatus: 'not_started' | 'started' | 'finished' | 'reviewed'
  workTitle: string
  locationName: string
  isLate: boolean
}

const WorkMarker: React.FC<Props> = ({workId, position, workStatus, workTitle, locationName, isLate }) => {
  const iconProps = statusToIcon(workStatus)
  return (
    <EnhancedMarker
      position={position}
      icon={
        <Avatar {...iconProps} variant='rounded' />
      }
    >
      <Popup className='marker-popup'>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography className='expand-text'
            component={Link} 
            variant='h6' 
            href={`/works/${workId}`} 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none !important", 
              '&.MuiTypography-root': {
                color: isLate ? "error.main" : "text.secondary",
              },
              '&:hover': {
                textDecoration: "underline !important",
              },
            }}
          >
            {workTitle}
          </Typography>
          <Typography variant='body1' color="text.secondary">{iconProps.children}{iconProps.title}</Typography>
          <Typography variant='body1' color="text.secondary" >
            <HomeWorkRoundedIcon />
              <Box className='expand-text' component="span" >
                {locationName}
              </Box>
          </Typography>
        </Box>
      </Popup>
    </EnhancedMarker>
  )
}

export default WorkMarker

function statusToIcon(status: Props['workStatus']) {
  var statuses = {
    not_started: { sx: { bgcolor: '#8E8E8E' }, children: <EventRoundedIcon />, title: 'A realizar' },
    started: { sx: { bgcolor: '#0245CC' }, children: <TimelapseIcon />, title: 'Em andamento' },
    finished: { sx: { bgcolor: '#018923' }, children: <CheckCircleOutlinedIcon />, title: 'Finalizado' },
    reviewed: { sx: { bgcolor: '#006100' }, children: <VerifiedRoundedIcon />, title: 'Revisado' }
  }
  return statuses[status] || statuses.not_started
}
